import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'raviger'
import classnames from 'classnames'
import styled from 'styled-components'

const ReportSelector = ({ criteria }) => {
  const isActive = criteria === 'peer'
  return (
    <Container>
      <Container.Item>
        <Nav.Link
          as={Link}
          href="/comparison/peer"
          className={classnames({ active: isActive })}
        >
          Peer Comparison
        </Nav.Link>
      </Container.Item>
      <Container.Item>
        <Nav.Link
          as={Link}
          href="/comparison/criteria"
          className={classnames({ active: !isActive })}
        >
          Criteria Comparison
        </Nav.Link>
      </Container.Item>
    </Container>
  )
}

const Container = styled(Nav)`
  margin-bottom: 1rem;
  > .nav-item > .nav-link {
    color: gray;

    &.active {
      color: ${({ theme }) => theme.palette.primary[0]};
      border-bottom: 2px solid ${({ theme }) => theme.palette.primary[0]};
    }
  }
`

export default ReportSelector
